define('views/modals/claim/file-collection',[
    'jquery',
    'underscore',
    'mediator',

    'views/base/view',
    'views/base/collection',
    'lib/utils',

    'text!templates/modals/claim/file-collection-item.ejs'
], function(
    $, _, mediator,

    View, CollectionView, utils,

    templateItem
) {
    'use strict';

    var ClaimFileItem = View.extend({
        template: templateItem,
        tagName: 'tr',
        listen: {
            'change:progress model': 'onChangeProgress',
            'change:showProgress model': 'render'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
            if (this.model.get('canEdit')) {
                this.delegate('click', '.btn-danger', this.onDeleteClick);
            }
        },
        onDeleteClick: function() {
            this.model.destroy({ wait: true });
        },
        onChangeProgress: function(model, progress) {
            var _this = this;
            if (progress > 0) {
                if (progress >= 100) {
                    if (this.model.get('showProgress')) {
                        this.$('.progress').addClass('progress-hidden');
                        setTimeout(function() {
                            _this.model.set('showProgress', false);
                        }, 1000);
                    }
                } else {
                    this.model.set('showProgress', true);
                    this.$('.progress').removeClass('progress-hidden');
                }
            }
            this.$('.progress .bar').css('width', progress + '%');
        }
    });

    var ClaimFileCollectionView = CollectionView.extend({
        autoRender: true,
        tagName: 'tbody',
        region: 'claim-files',
        itemView: ClaimFileItem
    });

    return ClaimFileCollectionView;
});

